import { isolateComponent, labelStyles, withModifier, } from '@zapier/style-encapsulation';
const Styles = labelStyles('ContentSection', {
    root: (props) => [
        {
            maxWidth: 1280,
            margin: '0 auto',
        },
        withModifier(props.size, {
            small: { padding: '0 10px' },
            medium: { padding: '0 20px' },
            large: { padding: '0 40px' },
        }[props.size]),
    ],
});
export const ContentSection = (props) => (isolateComponent("div", { css: Styles.root(props) }, props.children));
ContentSection.defaultProps = {
    size: 'small',
};
//# sourceMappingURL=ContentSection.js.map
// @zapier/design-system@6.1.0 (fd86aa2ab)
